module.exports = __webpack_public_path__ + "static/media/refer_and_earn.6b61dede.svg";